import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setdeleteUploadedFile,
    setloading,
    seterror,
    resetdeleteUploadedFile,
} from "../reducers/deleteUploadedFileReducer";

const deleteUploadedFile = (id: any, token: any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const result = await api.delete(`/ai/api/delete-file-upload/${id}/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            });

        if (result) {
            dispatch(setloading(false));
            dispatch(setdeleteUploadedFile(result.data));
        }
    } catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
};

export { deleteUploadedFile, resetdeleteUploadedFile };

